import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { baseTheme } from '../../../theme';
import { useDispatch, useSelector } from 'react-redux';
import { IIndividualFormData } from '../../../services/interfaces';
import React, { useState } from 'react';
import StandardInputComponent from '../../form-elements/standard-input';
import SubmitButton from '../../form-elements/submit-button';
import { loadUserDetails, setAppLoadingState } from '../../../store';
import { updateUserProfile } from '../../../store/users/actions';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        paddingRight: theme.spacing(0),
        paddingLeft: theme.spacing(0),
      },
      formContainers: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
      base: {
        width: '100%',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginLeft: 'auto',
        marginRight: 'auto',
        textAlign: 'center',
      },
      inputBase: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.primary.main,
        width: '100%',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        borderRadius: '5px',
      },
      submitButton: {
        fontSize: '2em',
      },
    }),
);

interface FormProps {
  cancel: () => void;
}

export default function AddContactEmail(Props: FormProps) {
  const cancel = Props.cancel;
  const classes = useStyles(baseTheme);
  const dispatch = useDispatch();
  const profile = useSelector((state: any) => state.user.profile);
  const currUser = useSelector((state: any) => state.auth.currUser);

  const defaultFormValues: IIndividualFormData = {
    displayName: '',
    password: '',
    confirmPass: '',
    email: '',
    contactEmail: '',
    timezone: '',
    referal: '',
    agreeTermsConditions: false,
    photoUrl: null,
    sortPreference: 'all',
    ...profile,
  };
  const [formValues, setFormValues] = useState(defaultFormValues);
  const [errorMessage, setErrorMessage] = useState('');
  const handleChange = (prop: any) => (event: any) => {
    setFormValues({ ...formValues, [prop]: event.target.value });
  };
  const handleSubmit = async () => {
    setAppLoadingState(dispatch, true);
    await updateUserProfile(currUser, formValues)
        .catch((err: any) => {
          console.log('error: ', err);
          setErrorMessage(err.message);
        });
    cancel();
    dispatch(await loadUserDetails(currUser.uid));
    setTimeout(
            () => setAppLoadingState(dispatch, false),
            500);
  };
  return (
        <>
            <Grid item container>
                <Grid item xs={6} className={classes.formContainers}>
                    <FormControl variant="filled" className={classes.inputBase}>
                        <StandardInputComponent
                            id="email"
                            label="Contact Email"
                            value={formValues.contactEmail}
                            onChange={handleChange('contactEmail')}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <Typography>
                      This is a contact email only.
                      Please continue to log in with email used at sign up.
                    </Typography>
                </Grid>
            </Grid>
            <Grid item container>
                <Grid item xs={12} md={6} className={classes.formContainers}>
                    <SubmitButton
                        className={classes.submitButton}
                        onClick={cancel}
                        text="Cancel"
                        variant="light"
                    />
                </Grid>
                <Grid item xs={12} md={6} className={classes.formContainers}>
                    <SubmitButton
                        className={classes.submitButton}
                        onClick={handleSubmit}
                        text="Save"
                        variant="light"
                    />
                </Grid>
            </Grid>
            <Grid item>
                {errorMessage}
            </Grid>
        </>
  );
}
